import axios from 'axios'
import { getIntegrationURLFromENVForPLD } from '../../../utils/getIntegrationURLFromENV'
import { sendErrorLog } from './perfiosTransaction'
import { ErrorLogUploadType } from './constants/ErrorLogUploadType.enum'

const FS_INSTITUTION_ID = '10996'
function urlInit() {
  const API_URL_PLD = getIntegrationURLFromENVForPLD()
  return { API_URL_PLD }
}

// Initiate FS transaction
export async function initiateFsTransaction() {
  try {
    const { API_URL_PLD } = urlInit()
    // Use default PLD endpoint (no application type needed)
    const INTEGRATION_ENDPOINT = API_URL_PLD

    // Static payload as provided
    const { data } = await axios.get(INTEGRATION_ENDPOINT + 'financial-statements/initiate-transaction')

    // Store FS transaction ID in localStorage for future API calls
    if (data && data.perfiosTransactionId) {
      const oldToken = window.localStorage.getItem('fsTransactionId')
      if (oldToken) {
        window.localStorage.removeItem('fsTransactionId')
      }
      const token = {
        perfiosTransactionId: data.perfiosTransactionId,
      }
      await window.localStorage.setItem('fsTransactionId', JSON.stringify(token))
    }

    return data
  } catch (error: any) {
    await sendErrorLog('FS_Initiate.json', '', '', error, ErrorLogUploadType.STATEMENT_UPLOAD)
    throw new Error(error?.response?.data?.message || error?.response?.data || error?.message)
  }
}

// Add Financial Year API
export async function addFinancialYear(
  file: File,
  financialYear: string,
  applicationId: string,
  isCurrentYear: boolean = false
) {
  try {
    const { API_URL_PLD } = urlInit()
    const INTEGRATION_ENDPOINT = API_URL_PLD

    // Get stored FS transaction ID
    const fsToken = window.localStorage.getItem('fsTransactionId')
    if (!fsToken) {
      throw new Error('FS transaction ID not found. Please initiate FS transaction first.')
    }
    const { perfiosTransactionId } = JSON.parse(fsToken)

    const formData = new FormData()
    formData.append('perfiosTransactionId', perfiosTransactionId)
    formData.append('financialYear', financialYear)
    formData.append('isDocumentScanned', 'true')
    formData.append('institutionId', FS_INSTITUTION_ID)
    formData.append('toPerfiosProcess', isCurrentYear ? 'true' : 'false')
    formData.append('applicationId', applicationId)
    formData.append('reportFile', file)

    const { data } = await axios.post(
      INTEGRATION_ENDPOINT + 'financial-statements/add-financial-year',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    if (data && data.s3Details.publicUrl && data.perfiosProcessed) {
      window.localStorage.setItem('fsCurrentYearUrl', data.s3Details.publicUrl)
      window.localStorage.setItem('fsCurrentYear', financialYear)
    }

    return data
  } catch (error: any) {
    await sendErrorLog('FS_AddFinancialYear.json', '', '', error, ErrorLogUploadType.STATEMENT_UPLOAD)
    throw new Error(error?.response?.data?.message || error?.response?.data || error?.message)
  }
}

// Final FS Upload API
export async function uploadFinancialStatements() {
  try {
    const { API_URL_PLD } = urlInit()
    const INTEGRATION_ENDPOINT = API_URL_PLD

    const fsToken = window.localStorage.getItem('fsTransactionId')
    if (!fsToken) {
      throw new Error('FS transaction ID not found')
    }
    const { perfiosTransactionId } = JSON.parse(fsToken)

    const publicUrl = window.localStorage.getItem('fsCurrentYearUrl')
    const financialYear = window.localStorage.getItem('fsCurrentYear') || '2024'
    
    if (!publicUrl) {
      return { message: 'No FS file to process' }
    }

    const payload = {
      filePath: [publicUrl],
      perfiosTransactionId,
      financialYear,
    }

    const { data } = await axios.post(
      INTEGRATION_ENDPOINT + 'financial-statements/upload',
      payload
    )

    console.log('FS upload successful')
    
    window.localStorage.removeItem('fsCurrentYearUrl')
    window.localStorage.removeItem('fsCurrentYear')
    
    return { year: financialYear, data }
  } catch (error: any) {
    await sendErrorLog('FS_Upload.json', '', '', error, ErrorLogUploadType.STATEMENT_UPLOAD)
    throw new Error(error?.response?.data?.message || error?.response?.data || error?.message)
  }
}
